window.$ = $;

window.alert = function (message, type = 'danger') {
	let $toast = $(`
        <div class="toast align-items-center text-white bg-${type} border-0" role="alert" aria-live="assertive" aria-atomic="true" data-delay="5000">
            <div class="toast-body d-flex" data-bs-dismiss="toast">
                <div class='me-2'>
                    ${message}
                </div>
                <button type="button" class="btn-close btn-close-white ms-auto" data-bs-dismiss="toast" aria-label="Close"></button>
            </div>
        </div>
    `);
	$('.toast-container').prepend($toast);
	$toast.toast('show');
};

window.escapeHTML = function (unsafe) {
	return unsafe
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#039;');
};

// przenosi pojedyncze znaki z końca linijki na początek następnej
export function addNbsps(el) {
	$(el)
		.find(':not(iframe):not(style):not(script)')
		.add(el)
		.contents()
		.filter((i, n) => n.nodeType == 3)
		.each(function () {
			var startWhitespace = /^\s/.test(this.nodeValue) ? ' ' : '';
			var endWhitespace = /\s$/.test(this.nodeValue) ? ' ' : '';
			this.nodeValue =
				startWhitespace + (' ' + this.nodeValue + ' ').replace(/(\s\w)\s+/g, '$1\xA0').trim() + endWhitespace;
		});
}

addNbsps('body');

$('[data-toggle="tooltip"]').tooltip();

$.fn.initJs = function () {
	$(window).trigger('init', this);
	return this;
};
export function onInit(selector, callback = null) {
	if (callback === null) {
		callback = selector;
		$(window).on('init', (e, el) => callback.bind(el)(el, e));
	} else {
		$(window).on('init', (e, el) => $(selector, el).each((index, element) => callback.bind(element)(element, e, el)));
	}
}
Object.defineProperty($, 'init', {
	set(fn) {
		$(window).on('init', function (e, el) {
			fn(el, e);
		});
	},
});
window.addEventListener('DOMContentLoaded', () => $('body').initJs());

document.addEventListener('DOMContentLoaded', () => {
	const fileInputs = document.querySelectorAll('.file-upload__file');

	fileInputs.forEach((input) => {
		input.addEventListener('change', () => {
			const fileName = input.files.length > 0 ? input.files[0].name : '';
			const titleEl = input.closest('.file-upload').querySelector('.file-upload__file-title');

			if (titleEl) {
				titleEl.textContent = fileName;
			}
		});
	});

	const tooltips = document.querySelectorAll('.label-tooltip');

	tooltips.forEach((tooltip) => {
		const button = tooltip.querySelector('.label-tooltip__button');

		button.addEventListener('click', (e) => {
			e.stopPropagation();
			e.preventDefault();

			tooltips.forEach((t) => {
				if (t !== tooltip) {
					t.classList.remove('is-active');
				}
			});

			tooltip.classList.toggle('is-active');
		});
	});

	// klik poza tooltips -> zamknij wszystkie
	document.addEventListener('click', () => {
		tooltips.forEach((tooltip) => tooltip.classList.remove('is-active'));
	});
});
